import React from 'react'
import './CustomMetaFileTypeIcon.scss'
import otherFileIcon from 'assets/icons/file-input-icons/other-file.png'
import pngIcon from 'assets/icons/file-input-icons/png.png'
import mp4Icon from 'assets/icons/file-input-icons/mp4.png'
import zipIcon from 'assets/icons/file-input-icons/zip.png'
import jpgIcon from 'assets/icons/file-input-icons/jpg.png'
import jsonIcon from 'assets/icons/file-input-icons/json.png'
import svgIcon from 'assets/icons/file-input-icons/svg.png'
import pdfIcon from 'assets/icons/file-input-icons/pdf.png'
import { utilityService } from 'services/UtilityService'
import { findFileExtension, getFileNameFromURL } from '../../../../util/util'
import { Icon, message, Tooltip } from 'antd'
import userMessages from 'constants/messages'
import CopyLinkIcon from 'components/ui/general/icons/CopyLinkIcon'
import InformationIcon from 'components/ui/general/icons/InformationIcon'

const CustomMetaFileTypeIcon = ({
  fileName = '',
  onClear = null,
  meta,
  fileNameToolTipPlacement = 'left',
  showCopyLink = true,
  getFileNameFlagFromURL = true
}) => {
  const extension = utilityService.toLowerCaseAndReplaceSpaces(findFileExtension(fileName))
  let icon = null
  if (extension === 'jpg') {
    icon = jpgIcon
  } else if (extension === 'png') {
    icon = pngIcon
  } else if (extension === 'json') {
    icon = jsonIcon
  } else if (extension === 'svg') {
    icon = svgIcon
  } else if (extension === 'pdf') {
    icon = pdfIcon
  } else if (extension === 'mp4') {
    icon = mp4Icon
  } else if (extension === 'zip') {
    icon = zipIcon
  } else {
    icon = otherFileIcon
  }
  let fileNameFromURL = null
  if (fileName && getFileNameFlagFromURL) {
    fileNameFromURL = getFileNameFromURL(fileName)
    fileNameFromURL = fileNameFromURL?.split('_')?.pop() || ''
  }
  return (
    <div className='file-input-wrapper custom-meta-file-type-icon'>
      <div className='file-icon-wrapper'>
        <div className='label-wrapper'>
          {meta?.customMetaLabel && <label>{meta.customMetaLabel}</label>}
          {meta?.customMetaToolTip && (
            <Tooltip placement='right' title={meta.customMetaToolTip}>
              <span className='asset-info-icon-boolean'>
                <InformationIcon />
              </span>
            </Tooltip>
          )}
        </div>
        <div className='file-icon-image'>
          <div className='file-actions-wrapper'>
            <div className={`inner ${(showCopyLink || onClear) && 'has-content'} `}>
              {
                showCopyLink &&
                <Tooltip placement='top' title='Copy Original File URL'>
                  <span
                    onClick={() => {
                      const textField = document.createElement('textarea')
                      textField.innerText = fileName
                      document.body.appendChild(textField)
                      textField.select()
                      document.execCommand('copy')
                      textField.remove()
                      message.success(userMessages.FILE_LINK_COPIED)
                    }}
                    className='copy-link-icon'
                  >
                    <CopyLinkIcon color={'white'} />
                  </span>
                </Tooltip>
              }
              {
                onClear &&
                <Tooltip placement='top' title='Clear Field'>
                  <Icon
                    type='close-circle'
                    theme='filled'
                    style={{ color: 'white' }}
                    onClick={() => onClear(meta, '')}
                  />
                </Tooltip>
              }
            </div>
          </div>
          <Tooltip placement={fileNameToolTipPlacement} title={fileNameFromURL}>
            <img
              src={icon}
              className='file-input-icon'
              onClick={() => {
                if (showCopyLink) {
                  window.open(fileName, '_blank').focus()
                }
              }}
            />
          </Tooltip>
        </div>
      </div>
    </div>
  )
}

export default CustomMetaFileTypeIcon
